var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    ref: "mainContainer",
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.isActiveReferralProgram ? _vm.$style.activeReferralProgram : _vm.$style.inactiveReferralProgram
  }, [_vm.isActiveReferralProgram ? _c('navigation-tabs') : _vm._e(), _c('project-layout', {
    attrs: {
      "shown-create": ""
    }
  }, _vm._l(_vm.projects, function (project) {
    return _c('project-card', {
      key: project.projectId,
      attrs: {
        "project": project
      }
    });
  }), 1), _vm.loadingPush ? _c('img', {
    attrs: {
      "src": require("@/assets/img/loader.svg")
    }
  }) : _vm._e()], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }